export enum ThemingOriginTypes  {
    INHERITED = 'Inherited',
    OVERRIDDEN = 'Overridden',
    DEFAULT = 'Default'
}